/// <reference path="BaseField.ts" />

namespace MACRAIL.Forms.Fields {

export class AutoComplete extends BaseField {

    protected opts: AutoCompleteOptions;

    private valueForHumans: string = '';
    private valueForHumansSelected: string = '';

    constructor (element: JQuery, opts: AutoCompleteOptions) {
        super(element, opts);

        let options: JQueryUI.AutocompleteOptions = {
            'source': opts.source,
            'select': (event: Event, ui: JQueryUI.AutocompleteUIParams) => {
                this.value = ui.item.id;

                let valueForHumans = ui.item.value;
                this.element.val(this.valueForHumans);
                this.valueForHumans = valueForHumans;
                this.valueForHumansSelected = valueForHumans;

                this.element.blur();
                this.element.trigger('change');

                if (this.opts.onSelect) {
                    this.opts.onSelect(event, ui);
                }
            },
        };

        if (opts.delay) {
            options.delay = opts.delay;
        }

        if (opts.hasOwnProperty('minLength')) {
            options.minLength = opts.minLength;
        }

        this.element.autocomplete(options);

        this.opts = opts;

        if (opts.openOnFocus || opts.selectTextOnFocus) {
            this.element.on('focus', (e) => {
                if (this.opts.openOnFocus) {
                    this.element.autocomplete('search', '');
                }
                if (this.opts.selectTextOnFocus) {
                    (this.element[0] as HTMLInputElement).select();
                }
            });
        }

        if (opts._renderItem) {
            this.element.data('ui-autocomplete')._renderItem = opts._renderItem;
        }

        this.element.on('blur', (e) => {
            if (this.element.val() !== this.valueForHumansSelected) {
                this.element.val(this.valueForHumansSelected);
            }
        });
    }

    public setValue(newValue: any) {
        if (newValue === undefined) {
            this.value = undefined;
            this.setValueForHumans('');
            this.element.trigger('change');
        }

        if (this.opts.mappingSource) {
            let mappingSource = this.opts.mappingSource;
            let mappingValue = this.opts.mappingValue;
            for (let item of mappingSource) {
                if (item[mappingValue] === newValue) {
                    this.value = newValue;
                    this.setValueForHumans(item[this.opts.mappingValueForHumans]);
                    this.element.trigger('change');
                    return;
                }
            }
        } else {
            super.setValue(newValue);
        }
    }

    public getValueForHumans() {
        return this.valueForHumans;
    }

    public setValueForHumans(valueForHumans: string) {
        this.valueForHumans = valueForHumans;
        this.valueForHumansSelected = valueForHumans;
        this.element.val(this.valueForHumans);
    }

    public setValues(value: any, valueForHumans: string) {
        this.value = value;
        this.setDirty(true);
        this.element.trigger('change');
        this.setValueForHumans(valueForHumans);
    }

}

interface AutoCompleteOptions extends FieldOptions {
    delay?: number;
    mappingSource: any[];
    mappingValue: string;
    mappingValueForHumans: string;
    minLength?: number;
    onSelect?: (event: Event, ui: JQueryUI.AutocompleteUIParams) => void;
    openOnFocus?: boolean;
    selectTextOnFocus?: boolean;
    source: any;
    _renderItem: (ui: JQueryUI.AutocompleteUIParams, item: any) => void;
    _renderMenu: (uli: JQuery, item: any[]) => void;
}

}
